import { ColorX } from "IZOX/STATIC";

/**
 * @type {{
 *  Colors: {
 *    Primary: String,
 *    Secondary: String,
 *    Third: String,
 *    Info: String,
 *    Warn: String,
 *    Fail: String,
 *    Success: String
 *  },
 *  BGColors: {
 *    Primary: String,
 *    Secondary: String,
 *    Third: String,
 *    Info: String,
 *    Warn: String,
 *    Fail: String,
 *    Success: String
 *  },
 *  FontSizes: {
 *    Title: Number,
 *    Subtitle: Number,
 *    Content: Number,
 *    DialogTitle: Number,
 *    DialogContent: Number,
 *    Button: Number,
 *    H1: Number,
 *    H2: Number,
 *    H3: Number,
 *    H4: Number
 *  }
 * }}
 */
export const SysTheme = {
  Colors: {
    Primary: ColorX.CSS("Leaf"),
    Secondary: ColorX.CSS("Grass"),
    Third: ColorX.CSS("NotQuiteWhite"),
    Info: ColorX.CSS("blue"),
    Warn: ColorX.CSS("yellow"),
    Fail: ColorX.CSS("red"),
    Success: ColorX.CSS("green")
  },
  BGColors: {
    Primary: ColorX.CSS("pureWhite"),
    Secondary: ColorX.CSS("pureWhite"),
    Third: ColorX.CSS("pureDark"),
    Info: ColorX.BgCSS("blue"),
    Warn: ColorX.BgCSS("yellow"),
    Fail: ColorX.BgCSS("red"),
    Success: ColorX.BgCSS("green"),
  },
  FontSizes: {
    Title: 22,
    Subtitle: 16,
    Content: 14,
    DialogTitle: 16,
    DialogContent: 14,
    Button: 14,
    H1: 34,
    H2: 30,
    H3: 24,
    H4: 20
  }
};